import { ExternalLink, Copy, Check, QrCode } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { VotingQRCode } from "../VotingQRCode";

export function VotingLinkSection({ consulta, id, copied, onCopy }) {
  const { t } = useTranslation();
  const votingUrl = `${window.location.origin}/vote/${id}`;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
      <h2 className="text-lg font-heading font-semibold text-blue-900 mb-2">{t('consultaDetail.votingLinkTitle')}</h2>
      <p className="text-sm text-blue-700 mb-4">{t('consultaDetail.shareLink')}</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <p className="text-xs font-medium text-blue-800 mb-2 flex items-center gap-1">
            <ExternalLink className="h-3 w-3" /> {t('consultaDetail.webLink')}
          </p>
          <div className="flex gap-2">
            <div className="flex-1 p-3 bg-white rounded-lg border border-blue-200 font-mono text-sm truncate">{votingUrl}</div>
            <Button variant="outline" onClick={onCopy} className="border-blue-200 text-blue-700 hover:bg-blue-100" data-testid="copy-url-btn">
              {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
            </Button>
            <a href={votingUrl} target="_blank" rel="noreferrer">
              <Button variant="outline" className="border-blue-200 text-blue-700 hover:bg-blue-100" data-testid="open-voting-btn">
                <ExternalLink className="h-4 w-4" />
              </Button>
            </a>
          </div>
        </div>
        <div className="flex flex-col items-center">
          <p className="text-xs font-medium text-blue-800 mb-2 flex items-center gap-1">
            <QrCode className="h-3 w-3" /> {t('consultaDetail.qrCode')}
          </p>
          <VotingQRCode url={votingUrl} title={consulta.title} size={160} />
        </div>
      </div>
    </div>
  );
}
